/**
 * Mapa central de endpoints REST, agrupados por microsserviço (ver `environment.apiUrls`).
 * Endpoints marcados como "confirmado" foram observados via inspeção de rede em
 * portal-hml.affixtech.com.br (21/08/2026). Os demais são inferidos a partir dos
 * padrões de tela (Ações/Filtrar/Incluir) e precisam de validação com o backend.
 */
export const endpoints = {
    infraestrutura: {
    // LEGADO — endpoints do backend antigo (api-infraestrutura.hml).
    // Mantidos apenas como referência; não são mais chamados.
    login: 'Auth/Credentials',
    validateTwoFactor: 'Auth/2FA/Validate',

    // API v1 — base em environment.apiUrls.infraestrutura termina em /api
    loginV1: 'v1/auth/login',
    validateTwoFactorV1: 'v1/auth/2fa/validate',

    users: 'Users', // TODO: confirmar
    userProfiles: 'UserProfiles', // TODO: confirmar
  },
  gestaoMedica: {
    list: 'GestaoMedica', // TODO: confirmar rota de listagem
    filtroSituacaoProposta: 'Filtro/ListarSituacaoProposta', // confirmado
    filtroFiliais: 'Filtro/ListarFiliais', // confirmado
    filtroSituacaoDocumento: 'Filtro/ListarSituacaoDocumento', // confirmado
    filtroSituacaoAuditoria: 'Filtro/ListarSituacaoAuditoria', // confirmado
    filtroMotivoAuditoria: 'Filtro/ListarMotivoAuditoria', // confirmado
    filtroSituacaoMedico: 'Filtro/ListarSituacaoMedico', // confirmado
    filtroAdministradoras: 'Filtro/ListarAdministradoras', // confirmado (+ /{codigoFilial})
  },
  preCadastro: {
    list: 'PreCadastro', // TODO: confirmar
    filtrar: 'PreCadastro/Filtrar', // TODO: confirmar
    gerarCsv: 'PreCadastro/GerarCsv', // TODO: confirmar
    baixarDocumentos: 'PreCadastro/BaixarDocumentos', // TODO: confirmar
    solicitacaoDownloads: 'PreCadastro/SolicitacaoDownloads', // TODO: confirmar
    totalizadores: 'PreCadastro/Totalizadores', // TODO: confirmar
    implantarComPendencias: 'PreCadastro/ImplantarComPendencias', // TODO: confirmar
    csvPendencias: 'PreCadastro/CsvPendencias', // TODO: confirmar
  },
    comunicados: {
    // Migrado para a API v1 do Portal Multiempresas (Swagger confirmado).
    // Base em environment.apiUrls.comunicados termina em /api.
    listar: 'v1/comunicados',
    criar: 'v1/comunicados',
    obterPorId: (id: string) => `v1/comunicados/${id}`,
    atualizar: (id: string) => `v1/comunicados/${id}`,
    envios: (id: string) => `v1/comunicados/${id}/envios`,
    inativar: (id: string) => `v1/comunicados/${id}/inativar`,
    disparar: (id: string) => `v1/comunicados/${id}/disparar`,
    uploadImagem: (id: string, tipo: string) =>
      `v1/comunicados/${id}/imagens/${tipo}`,

    
  },
  atendimento: {
    retencaoSegurado: 'v1/atendimento/retencao',
    retencaoAplicar:'v1/atendimento/retencao/aplicar',
    retencaoRecusar:'v1/atendimento/retencao/recusar',
    retencaoIndisponivel:'v1/atendimento/retencao/indisponivel',

    
    pagamentoCartaoCredito: 'Atendimento/PagamentoCartaoCredito', // TODO: confirmar
    recuperacaoCancelados: 'Atendimento/RecuperacaoCancelados', // TODO: confirmar
  },
  controleUsuarios: {
    buscarPorNome: 'Users/BuscarPorNome', // TODO: confirmar
  },
  titulosPendentes: {
    listar: 'v1/titulos-pendentes',
    enviarEmail: 'v1/titulos-pendentes/enviar-email',
  },
  extratos: {
    list: 'ExtratosCorretores', // TODO: confirmar
    relatorios: 'ExtratosCorretores/Relatorios', // TODO: confirmar
  },
  propostaMigracao: {
    list: 'PropostaMigracao', // TODO: confirmar
  },
  iaRetencao: {
    list: 'IaRetencaoCancelamento', // TODO: confirmar
  },
  financeiro: {
    acompanhamentoRemessa: 'Financeiro/AcompanhamentoRemessa', // TODO: confirmar
    faturamentoBeneficiario: 'Financeiro/FaturamentoBeneficiario', // TODO: confirmar
    liberacaoFaturamentoRapa: 'Financeiro/LiberacaoFaturamentoRapa', // TODO: confirmar
    dashboardCobranca: 'Financeiro/DashboardCobranca', // TODO: confirmar
    logTitulosAutomaticos: 'Financeiro/LogTitulosAutomaticos', // TODO: confirmar
  },
  modeloProposta: {
    cadastroModeloMigracao: 'ModeloProposta/Migracao', // TODO: confirmar
    cadastroModeloVendaOnline: 'ModeloProposta/VendaOnline', // TODO: confirmar
  },
  estudosMigracao: {
    list: 'EstudosMigracao', // TODO: confirmar (tela sem dados carregados na varredura)
  },
  vendaOnline: {
    list: 'VendaOnline', // TODO: confirmar
  },
};
